import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // View actions
  getEventsByStudentScroll: ['eventType', 'page'],
  // Reducer
  getEventsByStudentScrollRequest: null,
  getEventsByStudentScrollRequestMore: null,
  getEventsByStudentScrollRequestShowMore: null,
  getEventsByStudentScrollSuccess: null,
  getEventsByStudentScrollFailure: ['error']
});

export { Creators, Types };
